export default {
  name: "Recruitment Information",
  prefix: "F.e",
  sections: [
    {
      name: "Two of three entries required*",
      fields: [
        {
          code: "F.e.1",
          machine_name: "recApplyPhone",
          widget: "phone",
          label: "Telephone Number to Apply",
          validate: [
            "phone",
            {
              subsetOfSetRequired: "recApplyPhone",
              message:
                "Enter at least two (2) verifiable methods by which prospective U.S. workers can contact the employer and apply for the job opportunity.",
              needsFieldValues: true,
              extraData: {
                numRequired: 2,
                fieldArray: ["recApplyPhone", "recApplyEmail", "recApplyUrl"],
              },
            },
          ],
          tooltip: `Enter the area code and telephone number by which prospective U.S. workers can contact the employer and apply for the
                          job opportunity. If a phone number is not available, leave this field BLANK and the system will insert "N/A" at submission of
                          the application.`,
        },
        {
          code: "F.e.2",
          machine_name: "recApplyEmail",
          widget: "text",
          validate: [
            {
              email: {
                extraData: {
                  allowNAs: true,
                },
              },
            },
            {
              subsetOfSetRequired: "recApplyEmail",
              message: "Two of these three fields must be filled out.",
              needsFieldValues: true,
              extraData: {
                numRequired: 2,
                fieldArray: ["recApplyPhone", "recApplyEmail", "recApplyUrl"],
                allowNAs: false,
              },
            },
          ],
          label: "Email Address to Apply",
          maxLength: 60,
          tooltip: `Enter the e-mail address by which prospective U.S. workers can contact the employer and apply for the job opportunity.
                          The format must be name@emailaddress.top-leveldomain. If an e-mail address is not available, please enter "N/A".`,
        },
        {
          code: "F.e.3",
          machine_name: "recApplyUrl",
          widget: "text",
          label: "Website address (URL) to Apply",
          validate: [
            {
              url: {
                extraData: {
                  allowNAs: true,
                },
              },
            },
            {
              subsetOfSetRequired: "recApplyUrl",
              message: "Two of these three fields must be filled out.",
              needsFieldValues: true,
              extraData: {
                numRequired: 2,
                fieldArray: ["recApplyPhone", "recApplyEmail", "recApplyUrl"],
                allowNAs: false,
              },
            },
          ],
          maxLength: 70,
          tooltip: `Enter the website address by which prospective U.S. workers can contact the employer and apply for the job opportunity.
                          The format must be domain name.domain suffix. If a website address is not available, please enter "N/A". Examples of
                          valid suffixes include:
                          <br> .gov - Government agencies
                          <br> .mil – Military
                          <br> .org - Organizations (nonprofit)
                          <br> .edu - Educational institutions
                          <br> .com - Commercial business
                          <br> .net - Network organizations`,
        },
      ],
    },
  ],
};
